<div class="row wrapper tutorial-list" [ngClass]="{'admin':isAdmin,'ordering': isOrdering}">
  <header class="col-lg-12">
    <h2>Tutoriais</h2>
    <mat-slide-toggle class="example-margin" labelPosition="before"  *ngIf="permission"
      [(ngModel)]="isAdmin" [disabled]="false" (change)="changeStatusAdmin()">
      Modo Administrador
    </mat-slide-toggle>
  </header>
  <app-tutorial-item-list [isAdmin]="isAdmin" [isOrdering]="isOrdering" [data]="data" type="tutorial"
    (saveList)="saveList($event)" (deleteList)="deleteList($event)" (excluir)="excluir($event)" (openModal)="openModal($event)"
    (changeShow)="changeShow($event)" (openItem)="openTutorial($event)"></app-tutorial-item-list>
</div>
  
<ng-template #modal>
  <app-tutorial-edit [id]="currentId" type="group" (closeModal)="closeModal()" ></app-tutorial-edit>
</ng-template>

<app-loading [loader]="isLoading"></app-loading>